    /* ********** 环境切换 ********** */
    
    // 正式环境
    // export const BaseOssUrlDemo = 'https://taozhuanr-real.oss-cn-beijing.aliyuncs.com'; // oss 上传视频
    // export const BaseUrlOld = 'https://www.zhenhuizhuang.cn:8082';
    // export const BaseUrlNew = 'https://www.zhenhuizhuang.cn:8081';

    // 测试环境
    export const BaseOssUrlDemo = 'https://taozhuanr.oss-cn-beijing.aliyuncs.com'; // oss 上传视频
    export const BaseUrlOld = 'https://test.zhenhuizhuang.cn:8091'; // 1.0
    export const BaseUrlNew = 'https://test.zhenhuizhuang.cn:8090'; // 2.0
    

    
    // 演示环境
    // export const BaseOssUrlDemo = 'https://taozhuanr-staging.oss-cn-beijing.aliyuncs.com'; // oss 上传视频
    // export const BaseUrlOld = 'https://api1ys.zhenhuizhuang.cn'; // 1.0
    // export const BaseUrlNew = 'https://api2ys.zhenhuizhuang.cn'; // 2.0

    // 测试环境 - 外网
    // export const BaseOssUrlDemo = 'https://taozhuanr.oss-cn-beijing.aliyuncs.com'; // oss 上传视频
    // export const BaseUrlOld = 'https://zhenhuizhuang.cn:8009'; // 1.0
    // export const BaseUrlNew = 'https://zhenhuizhuang.cn:8083'; // 2.0



// WEBPACK FOOTER //
// ./src/api/NewSiteUrl.js